webpackJsonp([276406500309524],{

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookRouter = __webpack_require__(64);
	
	var _LoreHookRouter2 = _interopRequireDefault(_LoreHookRouter);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookRouter2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'history'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Whether browser should use pushState or hash to keep track of routes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/ReactTraining/react-router/blob/v3.2.0/docs/guides/Histories.md' },
	        'https://github.com/ReactTraining/react-router/blob/v3.2.0/docs/guides/Histories.md'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/ReactTraining/react-router/blob/master/docs/guides/Histories.md' },
	        'type of router history'
	      ),
	      ' you want to use in your application.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Typically ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'browserHistory'
	      ),
	      ' if you want to use pushState routes like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'https://www.myapp.com/posts/1'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'hashHistory'
	      ),
	      ' if you want to use hash-bang (#) style routes like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'https://www.myapp.com/#/posts/1'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { browserHistory } from \'react-router\';\n      ...\n      history: browserHistory\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-router-config-history-js-4268ca5d9ebaa89b3fcf.js